import(/* webpackMode: "eager" */ "/srv/src/app/global-error.tsx");
